import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import IconButton, { IconButtonType } from 'Components/Atoms/IconButton';
import './DoorIconButton.scss';

type Props = Omit<IconButtonType, 'size' | 'title' | 'aria-label'> & {
  /** Accessible name; also the tooltip unless `tooltip` is given. */
  label: string;
  tooltip?: string;
};

/**
 * Every icon action of the ticket door in the dashboard's form: the small system IconButton
 * (no disc, no ring) with a tooltip, as in tables and modal headers elsewhere, inside a 44 px
 * touch target for the door. The wrapper keeps the tooltip working on a disabled button.
 */
const DoorIconButton: React.FC<Props> = ({ label, tooltip, className = '', children, ...props }) => (
  <Tooltip title={tooltip ?? label}>
    <span className="door-icon-action-wrap">
      <IconButton {...props} size="small" aria-label={label} className={`door-icon-action ${className}`.trim()}>
        {children}
      </IconButton>
    </span>
  </Tooltip>
);

export default DoorIconButton;
